<template>
  <v-select
      v-model="input"
      :items="siteTypes"
      item-text="keyAlias"
      item-value="key"
      :error-messages="errors !== undefined ? errors : []"
      label="نوع زبان سایت"
      outlined
      :return-object="return_object"
      :dense="dense"
  ></v-select>
</template>

<script>

export default {
  props: ['value', 'errors','dense', 'return_object'],

  data() {
    return {
      input: this.value,
      siteTypes: [
        {key:'persian',keyAlias:'تک زبانه(فارسی)'},
        {key:'persianEnglish',keyAlias:'دو زبانه(فارسی و انگلیسی)'},
        {key:'multiLanguage',keyAlias:'چندزبانه'},
      ],

    }
  },
  name: "siteSelect",
  watch : {
    input(){
      this.$emit('input', this.input)
    }
  }
}
</script>

<style scoped>

</style>